import { RootState } from 'editor/src/store/index';

const isVariantsSidebarVisible = (state: RootState) => state.variants.variationGroups.length > 0;

export default isVariantsSidebarVisible;
